import React from 'react';
import { motion } from 'framer-motion';
import { TruckIcon, RotateCcwIcon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
export function ShippingReturns() {
  const highlights = [{
    icon: TruckIcon,
    title: 'Free Shipping',
    desc: 'On all orders over $300 within the US.'
  }, {
    icon: GlobeIcon,
    title: 'Worldwide Delivery',
    desc: 'International shipping to over 50 countries.'
  }, {
    icon: RotateCcwIcon,
    title: '30-Day Returns',
    desc: 'Hassle-free returns on ready-to-wear items.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Secure Packaging',
    desc: 'Every piece is hand-wrapped with care.'
  }];
  const sections = [{
    title: 'Domestic Shipping',
    content: 'We offer complimentary standard shipping on all US orders over $300. Standard delivery takes 3-5 business days, while expedited shipping (1-2 business days) is available at checkout for an additional fee. All orders are processed within 1-2 business days.'
  }, {
    title: 'International Shipping',
    content: 'We ship worldwide via trusted courier partners including DHL and FedEx. International delivery times range from 7-14 business days depending on destination. Please note that international customers are responsible for any customs duties or taxes imposed by their country.'
  }, {
    title: 'Returns Policy',
    content: 'Ready-to-wear pieces may be returned within 30 days of receipt for a full refund, provided they are in original condition with all tags attached. Items must be unworn, unwashed, and free from any signs of use. Please initiate your return by contacting our customer service team.'
  }, {
    title: 'Bespoke & Custom Orders',
    content: 'Due to the personalized nature of our bespoke services, custom-made pieces are non-refundable. We work closely with each client during the design process to ensure complete satisfaction with the final piece. Alterations are available at our Alexandria studio.'
  }, {
    title: 'Exchanges',
    content: 'We are happy to facilitate exchanges for different sizes or colors within 30 days of purchase, subject to availability. Please contact our team to arrange an exchange. Original shipping fees are non-refundable.'
  }, {
    title: 'Damaged or Defective Items',
    content: 'In the rare event that you receive a damaged or defective item, please contact us within 7 days of receipt with photographs of the issue. We will arrange for a replacement or full refund at no cost to you.'
  }];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-793">
      <div className="max-w-4xl mx-auto" data-id="element-794">
        <motion.header initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-20 text-center" data-id="element-795">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-6 block text-black/40" data-id="element-796">
            Customer Service
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-797">
            Shipping & Returns
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-798">
            Crafted with care. Delivered with intention.
          </p>
        </motion.header>

        {/* Highlights Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-24" data-id="element-799">
          {highlights.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="text-center" data-id="element-800">
              <item.icon className="w-8 h-8 mx-auto mb-4 stroke-[1.5px]" data-id="element-801" />
              <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-2" data-id="element-802">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm font-normal text-black/50 tracking-wide leading-relaxed" data-id="element-803">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="space-y-16" data-id="element-804">
          {sections.map((section, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border-l-2 border-black pl-8" data-id="element-805">
              <div className="flex items-baseline space-x-4 mb-4" data-id="element-806">
                <span className="text-xs md:text-sm font-display font-bold tracking-widest text-black/30" data-id="element-807">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase" data-id="element-808">
                  {section.title}
                </h2>
              </div>
              <p className="text-sm md:text-base font-normal text-black/70 leading-relaxed tracking-wide" data-id="element-809">
                {section.content}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-24 pt-12 border-t border-grey-divider text-center" data-id="element-810">
          <h3 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase mb-6" data-id="element-811">
            Need Assistance?
          </h3>
          <p className="text-sm md:text-base font-normal text-black/60 mb-8" data-id="element-812">
            Our concierge team is available to assist you with any shipping or
            returns inquiries.
          </p>
          <a href="tel:5718423307" className="inline-block bg-black text-white px-12 py-4 text-xs font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors" data-id="element-813">
            Contact Concierge
          </a>
        </div>
      </div>
    </div>;
}